import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import axios from "axios";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Paginator } from "primereact/paginator";
import { Link } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import LoadingSpinner from "../Spinner/LoadingSpinner";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { RowsPerPageDropdown } from "../../enums/RowsPerPageOptions";
import { Tooltip } from "primereact/tooltip";
import * as GlobalEnum from "../../enums/GlobalEnum";
import * as Designations from "../../enums/Designations";
import moment from "moment";
import * as Travelmodes from "../../enums/Travelmodes";
import { MultiSelect } from "primereact/multiselect";
import exportData from "../../services/exportToExcelService";
import AccessControl from "../AccessControl";
import { Dialog } from "primereact/dialog";


const ViewAttendeeStatus = () => {
    const [participantlist, setParticipantlist] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [fullName, setfullName] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [companyNameFilter, setcompanyNameFilter] = useState(null);
    const [filterEmail, setFilterEmail] = useState(null);
    const [filterMobileNo, setFilterMobileNo] = useState(null);
    const [SerialNumber, setSerialNumber] = useState(null);
    const [HotelFilter, setHotelFilter] = useState(null);
    const [InBatchfilter, setInBatchfilter] = useState(null);
    const [OutBatchfilter, setOutBatchfilter] = useState(null);
    const [boardingcityfilter, setboardingcityfilter] = useState(null);
    const [Cityfilter, setCityfilter] = useState(null);
    const [filterFlightNo, setFilterFlightNo] = useState(null);
    const [filterReturnFlightNo, setFilterReturnFlightNo] = useState(null);
    const [companyList, setCompanyList] = useState([]);
    const [inBatchList, setInBatchList] = useState([]);
    const [outBatchList, setOutBatchList] = useState([]);
    const [tricoConfirmedList, setTricoConfirmedList] = useState([]);
    const [arrivalDepartureDates, setArrivalDepartureDates] = useState(null);
    const [filterDialog, setFilterDialog] = useState(false);
    const [isArrivedFilterState, setIsArrivedFilterState] = useState(null);
    const [isCheckedInFilterState, setIsCheckedInFilterState] = useState(null);
    const [day1PresentFilterState, setDay1PresentFilterState] = useState(null);
    const [day2PresentFilterState, setDay2PresentFilterState] = useState(null);
    const [toEventCityFilterState, setToEventCityFilterState] = useState(null);
    const [fromEventCityFilterState, setFromEventCityFilterState] = useState(null);
    const [designationFilterState, setDesignationFilterState] = useState(null);
    const [arrivalTimeFilterState, setArrivalTimeFilterState] = useState(null);
    const [departureTimeFilterState, setDepartureTimeFilterState] = useState(null);
    const [tricoConfirmedFilterState, setTricoConfirmedFilterState] = useState(null);

    const lazyState = useRef({
        first: 0,
        rows: RowsPerPageDropdown[0],
        page: 1,
        sortField: null,
        sortOrder: 1,
        CompanyFilter: null,
        ParticipantNameFilter: null,
        EmailFilter: null,
        MobileNoFilter: null,
        BoardingCityFilter: null,
        serialnumber: null,
        IsArrivedfilter: null,
        IsCheckedInfilter: null,
        HotelFilter: null,
        inbatchfilter: null,
        outbatchfilter: null,
        TricoConfirmedfilter: null,
        Designationfilter: null,
        CityFilter: null,
        ArrivalTimefilter: null,
        DepartureTimefilter: null,
        flightNo: null,
        returnflightno: null,
        Toeventcityfilter: null,
        Fromeventcityfilter: null,
        day1presentfilter: null,
        day2presentfilter: null
    }); // For Sorting And Pagination Purpose

    // Const
    const toast = useRef(null);
    const dt = useRef(null);

    // On Screen Load
    useEffect(() => {
        getparticipantlist();
        getFilterListsData();
        getData();
    }, []);

    // Get All Participants
    const getparticipantlist = (isExportExcel = false, event) => {
        //In Booking Batch
        var listInBatchFilterString = null;
        if (lazyState.current.inbatchfilter != null && lazyState.current.inbatchfilter != undefined && lazyState.current.inbatchfilter != '') {
            if (lazyState.current.inbatchfilter.length > 0) {
                if (lazyState.current.inbatchfilter.length > 1) {
                    listInBatchFilterString = lazyState.current.inbatchfilter.map(item => item.name).join(',');
                } else {
                    listInBatchFilterString = lazyState.current.inbatchfilter.map(item => item.name)[0];
                }
            }
        }

        //Out Booking Batch
        var listOutBatchFilterString = null;
        if (lazyState.current.outbatchfilter != null && lazyState.current.outbatchfilter != undefined && lazyState.current.outbatchfilter != '') {
            if (lazyState.current.outbatchfilter.length > 0) {
                if (lazyState.current.outbatchfilter.length > 1) {
                    listOutBatchFilterString = lazyState.current.outbatchfilter.map(item => item.name).join(',');
                } else {
                    listOutBatchFilterString = lazyState.current.outbatchfilter.map(item => item.name)[0];
                }
            }
        }

        //Trico Confirmed Batch
        var listTricoConfirmedFilterString = null;
        if (lazyState.current.TricoConfirmedfilter != null && lazyState.current.TricoConfirmedfilter != undefined && lazyState.current.TricoConfirmedfilter != '') {
            if (lazyState.current.TricoConfirmedfilter.length > 0) {
                if (lazyState.current.TricoConfirmedfilter.length > 1) {
                    listTricoConfirmedFilterString = lazyState.current.TricoConfirmedfilter.map(item => item.name).join(',');
                } else {
                    listTricoConfirmedFilterString = lazyState.current.TricoConfirmedfilter.map(item => item.name)[0];
                }
            }
        }

        //Company
        var listCompanyFilterString = null;
        if (lazyState.current.CompanyFilter != null && lazyState.current.CompanyFilter != undefined && lazyState.current.CompanyFilter != '') {
            if (lazyState.current.CompanyFilter.length > 0) {
                if (lazyState.current.CompanyFilter.length > 1) {
                    listCompanyFilterString = lazyState.current.CompanyFilter.map(item => item.name).join(',');
                } else {
                    listCompanyFilterString = lazyState.current.CompanyFilter.map(item => item.name)[0];
                }
            }
        }

        setIsLoading(true);
        if (!isExportExcel) setParticipantlist([]);

        axios
            .post("/api/Participant/GetAll", {
                PaginationRequired: !isExportExcel,
                SortDirection: lazyState.current.sortOrder,
                PageSize: lazyState.current.rows,
                CurrentPageNumber: event && event.rows ? event.first / event.rows + 1 : lazyState.current.page,
                SortField: event && event.sortField ? event.sortField : "",
                registrationStatus: "APPROVED",
                CompanyFilter: listCompanyFilterString ? listCompanyFilterString : null,
                FullName: lazyState.current.ParticipantNameFilter ? lazyState.current.ParticipantNameFilter.trim() : null,
                Email: lazyState.current.EmailFilter ? lazyState.current.EmailFilter.trim() : null,
                MobileNo: lazyState.current.MobileNoFilter ? lazyState.current.MobileNoFilter.trim() : null,
                BoardingCity: lazyState.current.BoardingCityFilter ? lazyState.current.BoardingCityFilter.trim() : null,
                SerialNumber: lazyState.current.serialnumber ? lazyState.current.serialnumber.trim() : null,
                IsArrived: lazyState.current.IsArrivedfilter ? lazyState.current.IsArrivedfilter.code.trim() : null,
                IsCheckedIn: lazyState.current.IsCheckedInfilter ? lazyState.current.IsCheckedInfilter.code.trim() : null,
                HotelFilter: lazyState.current.HotelFilter ? lazyState.current.HotelFilter.trim() : null,
                InBatchBooking: listInBatchFilterString ? listInBatchFilterString : null,
                OutBatchBooking: listOutBatchFilterString ? listOutBatchFilterString : null,
                TricoConfirmed: listTricoConfirmedFilterString || (listTricoConfirmedFilterString === 'Not Assigned' ? 'Not Assigned' : null),
                City: lazyState.current.CityFilter ? lazyState.current.CityFilter.trim() : null,
                Designation: lazyState.current.Designationfilter ? lazyState.current.Designationfilter.name.trim() : null,
                ArrivalFilter: lazyState.current.ArrivalTimefilter ? lazyState.current.ArrivalTimefilter.code : null,
                Present: lazyState.current.day1presentfilter ? lazyState.current.day1presentfilter.code : null,
                DayTwoPresent: lazyState.current.day2presentfilter ? lazyState.current.day2presentfilter.code : null,
                DepartureFilter: lazyState.current.DepartureTimefilter ? lazyState.current.DepartureTimefilter.code : null,
                FlightNo: lazyState.current.flightNo ? lazyState.current.flightNo.trim() : null,
                ArrivalReturnFlightNo: lazyState.current.returnflightno ? lazyState.current.returnflightno.trim() : null,
                ToEventCity: lazyState.current.Toeventcityfilter ? lazyState.current.Toeventcityfilter.code.trim() : null,
                FromEventCity: lazyState.current.Fromeventcityfilter ? lazyState.current.Fromeventcityfilter.code.trim() : null,
                ParticipantHotel: true,
            })
            .then((Response) => {
                let tempData = [];
                const AttendeeStatus = "Attendee Status";

                for (let dataObj of Response.data.data) {
                    let allExcelData = {
                        Id: dataObj.serialNumber,
                        Name: dataObj.fullName,
                        IsCheckedIn: dataObj.isCheckedInYesNo,
                        IsArrived: dataObj.isArrivedYesNo,
                        Day1Present: dataObj.presentYesNo,
                        Day2Present: dataObj.dayTwoPresentYesNo,
                        Hotel: dataObj.hotelName,
                        FlightNo: dataObj.flightNo,
                        ReturnFlightNo: dataObj.returnFlightNo,
                        Arrival: dataObj.arrivalTime
                            ? moment(dataObj.arrivalTime).format("DD/MM/YYYY HH:mm")
                            : "",
                        Departure: dataObj.departureTime
                            ? moment(dataObj.departureTime).format("DD/MM/YYYY HH:mm")
                            : "",
                        TricoConfirmed: dataObj.tricoConfirmed,
                        InBatch: dataObj.inBatchBooking,
                        OutBatch: dataObj.outBatchBooking,
                        MobileNo: dataObj.mobileNo,
                        Email: dataObj.email,
                        Designation: dataObj.designation,
                        City: dataObj.cityname,
                        BoardingCity: dataObj.boardingcityname,
                        Company: dataObj.company,
                        TravelInBound: dataObj.travelmode_Inbound,
                        TravelOutBound: dataObj.travelmode_Outbound
                    };
                    tempData.push(allExcelData);
                }

                if (isExportExcel == true) {
                    exportData(tempData, AttendeeStatus);
                    setIsLoading(false);
                    return false;
                }

                setTotalRecords(Response.data.totalRecords);
                const ModifyParticipantList = Response.data.data.map((TricoConfirmedData) => ({
                    ...TricoConfirmedData,
                }));    
                setParticipantlist(ModifyParticipantList);
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                toast.current.show({ severity: "error", summary: "Error", detail: "Oops! Something Went Wrong!", life: 3000 });
            });
    };

    const getFilterListsData = () => {
        setIsLoading(true);
        axios
            .get("/api/Participant/GetAllFilterListData")
            .then((Response) => {
                const separatedLists = Response.data.reduce((acc, item) => {
                    // Create a new array for each type if it doesn't exist
                    if (!acc[item.type]) {
                        acc[item.type] = [];
                    }
                    // Push the formatted item to the respective array
                    acc[item.type].push({ name: item.name, code: item.name });
                    return acc;
                }, {});

                // Sort each list by 'name'
                Object.keys(separatedLists).forEach(type => {
                    separatedLists[type].sort((a, b) => a.name.localeCompare(b.name));
                });
                setCompanyList(separatedLists.Company || []);
                setInBatchList(separatedLists.InBatch || []);
                setOutBatchList(separatedLists.OutBatch || []);
                setTricoConfirmedList(separatedLists.TricoConfirmed || []);
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                toast.current.show({ severity: "error", summary: "Error", detail: "Oops! Something Went Wrong!", life: 3000 });
            });
    };

        const getData = () => {
        fetch("config.json", {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        })
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            const travelDateDays = parseInt(data[13].TravelDateDays); // Convert to integer
            const eventDayOne = new Date(data[9].EventDayOneDt);
            const eventDayTwo = new Date(data[10].EventDayTwoDt);
            
            // Function to format the date as dd-mm-yyyy
            const formatDate = (date) => {
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
            };

             // Function to format the date as dd-mm-yyyy
             const formatDateCode = (date) => {
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${year}-${month}-${day}`;
            };
    
            let dates = [];
            for (let i = travelDateDays; i >= 1; i--) {
                dates.push(new Date(eventDayOne.getTime() - i * 24 * 60 * 60 * 1000)); // Subtract i days from eventDayOne
            }
            dates.push(eventDayOne); 
            dates.push(eventDayTwo);
            for (let i = 1; i <= travelDateDays; i++) {
                dates.push(new Date(eventDayTwo.getTime() + i * 24 * 60 * 60 * 1000)); // Add i days to eventDayTwo
            }
    
            const formattedDates = dates.map((date) => {
                const formattedDate = formatDate(date);
                const formattedDateCode = formatDateCode(date);
                return { name: formattedDate, code: formattedDateCode };
            });    
            setArrivalDepartureDates(formattedDates); // Assuming you have a setter function for the dates
        });
    };

    const UserFilterTemplate = () => {
        return <InputText id="fullName" value={fullName} placeholder="Enter First Name" onChange={(e) => setfullName(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    };

    const SerialNumberFilterTemplate = () => {
        return <InputText id="serialnumber" value={SerialNumber} placeholder="Sr No." onChange={(e) => setSerialNumber(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: "5rem" }} />;
    };

    const BoardingCityFilterTemplate = () => {
        return <InputText id="boardingcityname" value={boardingcityfilter} placeholder="Enter Boarding City" onChange={(e) => setboardingcityfilter(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: "12rem" }} />;
    };
    const CompanyFilterTemplate = () => {
        return (
            <MultiSelect
                value={lazyState.current.CompanyFilter}
                options={companyList}
                itemTemplate={CompanyFilterItemTemplate}
                optionLabel="name"
                onChange={(e) => CompanyFilterClick(e)}
                placeholder="Select Any"
                className="p-column-filter"
                maxSelectedLabels={1}
                style={{ minWidth: '14rem' }}
                filter
            />
        );
    };

    const CompanyFilterItemTemplate = (option) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{option.name}</span>
            </div>
        );
    };

    const CompanyFilterBodyTemplate = (rowData) => {
        const company = rowData.company;
        return (
            <div className="flex align-items-center gap-2">
                <span>{company}</span>
            </div>
        );
    };

    const CompanyFilterClick = (e) => {
        lazyState.current.CompanyFilter = e.target.value ? e.target.value : null;
        getparticipantlist(false, { CompanyFilter: e.value });
        e.preventDefault();
    }

    const EmailFilterTemplate = () => {
        return <InputText id="Email" value={filterEmail} placeholder="Enter Email" onChange={(e) => setFilterEmail(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: "12rem" }} />;
    };

    const MobileFilterTemplate = () => {
        return <InputText id="Mobile" value={filterMobileNo} placeholder="Enter Mobile No." onChange={(e) => setFilterMobileNo(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: "12rem" }} />;
    };

    const InBatchFilterTemplate = () => {
        return (
            <MultiSelect
                value={lazyState.current.inbatchfilter}
                options={inBatchList}
                itemTemplate={InBatchFilterItemTemplate}
                optionLabel="name"
                onChange={(e) => InBatchFilterClick(e)}
                placeholder="Select Any"
                className="p-column-filter"
                maxSelectedLabels={1}
                style={{ minWidth: '14rem' }}
                filter
            />
        );
    };

    const InBatchFilterItemTemplate = (option) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{option.name}</span>
            </div>
        );
    };

    const InBatchFilterBodyTemplate = (rowData) => {
        const inBatch = rowData.inBatchBooking;
        return (
            <div className="flex align-items-center gap-2">
                <span>{inBatch}</span>
            </div>
        );
    };

    const InBatchFilterClick = (e) => {
        lazyState.current.inbatchfilter = e.target.value ? e.target.value : null;
        getparticipantlist(false, { InBatch: e.value });
        e.preventDefault();
    }

    const OutBatchFilterTemplate = () => {
        return (
            <MultiSelect
                value={lazyState.current.outbatchfilter}
                options={outBatchList}
                itemTemplate={OutBatchFilterItemTemplate}
                optionLabel="name"
                onChange={(e) => OutBatchFilterClick(e)}
                placeholder="Select Any"
                className="p-column-filter"
                maxSelectedLabels={1}
                style={{ minWidth: '14rem' }}
                filter
            />
        );
    };

    const OutBatchFilterItemTemplate = (option) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{option.name}</span>
            </div>
        );
    };

    const OutBatchFilterBodyTemplate = (rowData) => {
        const outBatch = rowData.outBatchBooking;
        return (
            <div className="flex align-items-center gap-2">
                <span>{outBatch}</span>
            </div>
        );
    };

    const OutBatchFilterClick = (e) => {
        lazyState.current.outbatchfilter = e.target.value ? e.target.value : null;
        getparticipantlist(false, { OutBatch: e.value });
        e.preventDefault();
    }

    const TricoConfirmedFilterTemplate = () => {
        return (
            <MultiSelect
                value={lazyState.current.TricoConfirmedfilter}
                options={tricoConfirmedList}
                itemTemplate={TricoConfirmedFilterItemTemplate}
                optionLabel="name"
                onChange={(e) => TricoConfirmedFilterClick(e)}
                placeholder="Select Any"
                className="p-column-filter"
                maxSelectedLabels={1}
                style={{ minWidth: '14rem' }}
                filter
            />
        );
    };

    const TricoConfirmedFilterBodyTemplate = (rowData) => {
        const tricoConfirmed = rowData.tricoConfirmed;
        return (
            <div className="flex align-items-center gap-2">
                <span>{tricoConfirmed}</span>
            </div>
        );
    };
    const TricoConfirmedFilterItemTemplate = (option) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{option.name}</span>
            </div>
        );
    };

    const TricoConfirmedFilterClick = (e) => {
        lazyState.current.TricoConfirmedfilter = e.target.value ? e.target.value : null;
        getparticipantlist(false, { TricoConfirmed: e.value });
        e.preventDefault();
    };


    const IsArrivedFilterTemplate = () => {
        return (
            <Dropdown
                value={lazyState.current.IsArrivedfilter}
                options={GlobalEnum.GlobalEnum}
                optionLabel="name"
                showClear
                onChange={(e) => {
                    lazyState.current.IsArrivedfilter = e.target.value ? e.target.value : null;
                    getparticipantlist(false, { IsArrived: e.value });
                    e.preventDefault();
                }}
                placeholder="Select Arrived Status"
                className="p-column-filter"
            />
        );
    };

    const Day1PresentFilterTemplate = () => {
        return (
            <Dropdown
                value={lazyState.current.day1presentfilter}
                options={GlobalEnum.GlobalEnum}
                optionLabel="name"
                showClear
                onChange={(e) => {
                    lazyState.current.day1presentfilter = e.target.value ? e.target.value : null;
                    getparticipantlist(false, { Present: e.value });
                    e.preventDefault();
                }}
                placeholder="Select Arrived Status"
                className="p-column-filter"
            />
        );
    };

    const Day2PresentFilterTemplate = () => {
        return (
            <Dropdown
                value={lazyState.current.day2presentfilter}
                options={GlobalEnum.GlobalEnum}
                optionLabel="name"
                showClear
                onChange={(e) => {
                    lazyState.current.day2presentfilter = e.target.value ? e.target.value : null;
                    getparticipantlist(false, { DayTwoPresent: e.value });
                    e.preventDefault();
                }}
                placeholder="Select Arrived Status"
                className="p-column-filter"
            />
        );
    };


    const IsCheckedInFilterTemplate = () => {
        return (
            <Dropdown
                value={lazyState.current.IsCheckedInfilter}
                options={GlobalEnum.GlobalEnum}
                optionLabel="name"
                showClear
                onChange={(e) => {
                    lazyState.current.IsCheckedInfilter = e.target.value ? e.target.value : null;
                    getparticipantlist(false, { IsCheckedIn: e.value });
                    e.preventDefault();
                }}
                placeholder="Select CheckedIn"
                className="p-column-filter"
            />
        );
    };

    const ToEventCityTemplate = () => {
        return (
            <Dropdown
                value={lazyState.current.Toeventcityfilter}
                options={Travelmodes.Travelmode}
                optionLabel="name"
                showClear
                onChange={(e) => {
                    lazyState.current.Toeventcityfilter = e.target.value ? e.target.value : null;
                    getparticipantlist(false, { ToEventCity: e.value });
                    e.preventDefault();
                }}
                placeholder="Select Travel Mode "
                className="p-column-filter"
                style={{ minWidth: "12rem" }}
            />
        );
    };

    const FromEventCityTemplate = () => {
        return (
            <Dropdown
                value={lazyState.current.Fromeventcityfilter}
                options={Travelmodes.Travelmode}
                optionLabel="name"
                showClear
                onChange={(e) => {
                    lazyState.current.Fromeventcityfilter = e.target.value ? e.target.value : null;
                    getparticipantlist(false, { FromEventCity: e.value });
                    e.preventDefault();
                }}
                placeholder="Select Travel Mode"
                className="p-column-filter"
                style={{ minWidth: "12rem" }}
            />
        );
    };

    const HotelFilterTemplate = () => {
        return <InputText id="Hotel" value={HotelFilter} placeholder="Enter Hotel" onChange={(e) => setHotelFilter(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: "12rem" }} />;
    };

    const DesignationFilterTemplate = () => {
        return (
            <Dropdown
                value={lazyState.current.Designationfilter}
                options={Designations.Designation}
                optionLabel="name"
                showClear
                onChange={(e) => {
                    lazyState.current.Designationfilter = e.target.value ? e.target.value : null;
                    getparticipantlist(false, { Designation: e.value });
                    e.preventDefault();
                }}
                placeholder="Select Designation"
                className="p-column-filter"
                style={{ minWidth: "12rem" }}
            />
        );
    };

    const CityFilterTemplate = (options) => {
        return <InputText id="city" value={Cityfilter} placeholder="Enter City" onChange={(e) => setCityfilter(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: "12rem" }} />;
    };

    const ArrivalTimerFilterTemplate = () => {
        return (
            <Dropdown
                value={lazyState.current.ArrivalTimefilter}
                options={arrivalDepartureDates}
                optionLabel="name"
                showClear
                onChange={(e) => {
                    lazyState.current.sortField = "ArrivalTime";
                    lazyState.current.ArrivalTimefilter = e.target.value ? e.target.value : null;
                    getparticipantlist(false, { ArrivalFilter: e.value }, lazyState.current);
                    e.preventDefault();
                }}
                placeholder="Select Arrival Time"
                className="p-column-filter"
                style={{ minWidth: "12rem" }}
            />
        );
    };
    const DepartureTimerFilterTemplate = () => {
        return (
            <Dropdown
                value={lazyState.current.DepartureTimefilter}
                options={arrivalDepartureDates}
                optionLabel="name"
                showClear
                onChange={(e) => {
                    lazyState.current.sortField = "DepartureTime";
                    lazyState.current.DepartureTimefilter = e.target.value ? e.target.value : null;
                    getparticipantlist(false, { DepartureFilter: e.value }, lazyState.current);
                    e.preventDefault();
                }}
                placeholder="Select Departure Time"
                className="p-column-filter"
                style={{ minWidth: "12rem" }}
            />
        );
    };

    const FlightNoFilterTemplate = () => {
        return <InputText id="flightno" value={filterFlightNo} placeholder="Enter FlightNo" onChange={(e) => setFilterFlightNo(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ width: "150px" }} />;
    };
    const ReturnFlightNoFilterTemplate = () => {
        return <InputText id="returnflightno" value={filterReturnFlightNo} placeholder="Enter FlightNo" onChange={(e) => setFilterReturnFlightNo(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ width: "150px" }} />;
    };

  
    const SearchFilter = () => {
        setIsLoading(true);  
        lazyState.current.ParticipantNameFilter = fullName;
        lazyState.current.HotelFilter = HotelFilter;
        lazyState.current.flightNo = filterFlightNo;
        lazyState.current.returnflightno = filterReturnFlightNo;
        lazyState.current.MobileNoFilter = filterMobileNo;
        lazyState.current.EmailFilter = filterEmail;
        lazyState.current.CityFilter = Cityfilter;
        lazyState.current.BoardingCityFilter = boardingcityfilter;
        lazyState.current.serialnumber = SerialNumber;
        getparticipantlist(false, lazyState.current);
        setFilterDialog(false);
        setIsLoading(false);
    };
  

    const UserFilterOnEnter = (e) => {
        if (e.key == "Enter") {
            if (e.target.value.trim() != null && e.target.value.trim() != "") {
                setIsLoading(true);
                let data = e.target.id;
                switch (data) {
                    case "fullName":
                        lazyState.current.ParticipantNameFilter = e.target.value ? e.target.value : null;
                        break;
                    case "boardingcityname":
                        lazyState.current.BoardingCityFilter = e.target.value ? e.target.value : null;
                        break;
                    case "city":
                        lazyState.current.CityFilter = e.target.value ? e.target.value : null;
                        break;
                    case "company":
                        lazyState.current.CompanyFilter = e.target.value ? e.target.value : null;
                        break;
                    case "Email":
                        lazyState.current.EmailFilter = e.target.value ? e.target.value : null;
                        break;
                    case "Mobile":
                        lazyState.current.MobileNoFilter = e.target.value ? e.target.value : null;
                        break;
                    case "serialnumber":
                        lazyState.current.serialnumber = e.target.value ? e.target.value : null;
                        break;
                    case "inbatch":
                        lazyState.current.inbatchfilter = e.target.value ? e.target.value : null;
                        break;
                    case "outbatch":
                        lazyState.current.outbatchfilter = e.target.value ? e.target.value : null;
                        break;
                    case "Hotel":
                        lazyState.current.HotelFilter = e.target.value ? e.target.value : null;
                        break;
                    case "flightno":
                        lazyState.current.flightNo = e.target.value ? e.target.value : null;
                        break;
                    case "returnflightno":
                        lazyState.current.returnflightno = e.target.value ? e.target.value : null;
                        break;
                }
                getparticipantlist(false, lazyState.current);
                setIsLoading(false);
            } else {
                setIsLoading(true);
                let data = e.target.id;
                switch (data) {
                    case "fullName":
                        lazyState.current.ParticipantNameFilter = null;
                        break;
                    case "boardingcityname":
                        lazyState.current.BoardingCityFilter = null;
                        break;
                    case "city":
                        lazyState.current.CityFilter = null;
                        break;
                    case "company":
                        lazyState.current.CompanyFilter = null;
                        break;
                    case "Email":
                        lazyState.current.EmailFilter = null;
                        break;
                    case "Mobile":
                        lazyState.current.MobileNoFilter = null;
                        break;
                    case "serialnumber":
                        lazyState.current.serialnumber = null;
                        break;
                    case "inbatch":
                        lazyState.current.inbatchfilter = null;
                        break;
                    case "outbatch":
                        lazyState.current.outbatchfilter = null;
                        break;
                    case "Hotel":
                        lazyState.current.HotelFilter = null;
                        break;
                    case "flightno":
                        lazyState.current.flightNo = null;
                        break;
                    case "returnflightno":
                        lazyState.current.returnflightno = null;
                        break;
                }
                getparticipantlist(false, lazyState.current);
                setIsLoading(false);
            }
        }
        if (e.type == 'click') {
            if (e.target.value.trim() != null && e.target.value.trim() != "") {
                setIsLoading(true);
                let data = e.target.id;
                switch (data) {
                    case "fullName":
                        lazyState.current.ParticipantNameFilter = e.target.value ? e.target.value : null;
                        break;
                    case "boardingcityname":
                        lazyState.current.BoardingCityFilter = e.target.value ? e.target.value : null;
                        break;
                    case "city":
                        lazyState.current.CityFilter = e.target.value ? e.target.value : null;
                        break;
                    case "company":
                        lazyState.current.CompanyFilter = e.target.value ? e.target.value : null;
                        break;
                    case "Email":
                        lazyState.current.EmailFilter = e.target.value ? e.target.value : null;
                        break;
                    case "Mobile":
                        lazyState.current.MobileNoFilter = e.target.value ? e.target.value : null;
                        break;
                    case "serialnumber":
                        lazyState.current.serialnumber = e.target.value ? e.target.value : null;
                        break;
                    case "inbatch":
                        lazyState.current.inbatchfilter = e.target.value ? e.target.value : null;
                        break;
                    case "outbatch":
                        lazyState.current.outbatchfilter = e.target.value ? e.target.value : null;
                        break;
                    case "Hotel":
                        lazyState.current.HotelFilter = e.target.value ? e.target.value : null;
                        break;
                    case "flightno":
                        lazyState.current.flightNo = e.target.value ? e.target.value : null;
                        break;
                    case "returnflightno":
                        lazyState.current.returnflightno = e.target.value ? e.target.value : null;
                        break;
                }
                getparticipantlist(false, lazyState.current);
                setIsLoading(false);
            } else {
                setIsLoading(true);
                let data = e.target.id;
                switch (data) {
                    case "fullName":
                        lazyState.current.ParticipantNameFilter = null;
                        break;
                    case "boardingcityname":
                        lazyState.current.BoardingCityFilter = null;
                        break;
                    case "city":
                        lazyState.current.CityFilter = null;
                        break;
                    case "company":
                        lazyState.current.CompanyFilter = null;
                        break;
                    case "Email":
                        lazyState.current.EmailFilter = null;
                        break;
                    case "Mobile":
                        lazyState.current.MobileNoFilter = null;
                        break;
                    case "serialnumber":
                        lazyState.current.serialnumber = null;
                        break;
                    case "inbatch":
                        lazyState.current.inbatchfilter = null;
                        break;
                    case "outbatch":
                        lazyState.current.outbatchfilter = null;
                        break;
                    case "Hotel":
                        lazyState.current.HotelFilter = null;
                        break;
                    case "flightno":
                        lazyState.current.flightNo = null;
                        break;
                    case "returnflightno":
                        lazyState.current.returnflightno = null;
                        break;
                }
                getparticipantlist(false, lazyState.current);
                setIsLoading(false);
            }
        }
    };

    // For Sorting
    const onSort = (event) => {
        lazyState.current.sortField = event.sortField;
        lazyState.current.sortOrder = event.sortOrder;
        lazyState.current.first = event.first;
        lazyState.current.rows = event.rows;
        getparticipantlist(false, lazyState.current);
    };

    //pagination
    const onBasicPageChange = (event) => {
        setIsLoading(true);
        lazyState.current.sortField = lazyState.current.sortField;
        lazyState.current.sortOrder = lazyState.current.sortOrder;
        lazyState.current.first = event.first;
        lazyState.current.rows = event.rows;
        getparticipantlist(false, lazyState.current);
        setIsLoading(false);
    };

    //Template for pagination
    const template2 = {
        layout: " CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
        CurrentPageReport: (options) => {
            return (
                <span className="paginator-current-report" style={{ color: "var(--text-color)", userSelect: "none", textAlign: "center" }}>
                    Showing {options.first} to {options.last} of {options.totalRecords} entries
                </span>
            );
        },
        RowsPerPageDropdown: (options) => {
            return (
                <span className="paginator-rows-per-page">
                    Items Per Page :<Dropdown value={options.value} options={RowsPerPageDropdown} onChange={options.onChange} />
                </span>
            );
        },
    };

    const ButtonMailto = (rowData) => {
        return (
            <Link
                className="linkcolors"
                id="mailto"
                to="#"
                onClick={(e) => {
                    window.location.href = `mailto:${rowData.email}`;
                    e.preventDefault();
                }}
            >
                {rowData.email}
            </Link>
        );
    };

    const ButtonPhoneto = (rowData) => {
        return (
            <Link
                className="linkcolors"
                id="callto"
                to="#"
                onClick={(e) => {
                    window.location.href = `tel:${rowData.mobileNo}`;
                    e.preventDefault();
                }}
            >
                {rowData.mobileNo}
            </Link>
        );
    };

    const removeFilter = () => {
        lazyState.current.CompanyFilter = null;
        setcompanyNameFilter(null);
        lazyState.current.ParticipantNameFilter = null;
        setfullName(null);
        lazyState.current.BoardingCityFilter = null;
        setboardingcityfilter(null);
        lazyState.current.EmailFilter = null;
        setFilterEmail(null);
        lazyState.current.MobileNoFilter = null;
        setFilterMobileNo(null);
        lazyState.current.Genderfilter = null;
        lazyState.current.serialnumber = null;
        setSerialNumber(null);
        setInBatchfilter(null);
        lazyState.current.inbatchfilter = null;
        setOutBatchfilter(null);
        lazyState.current.outbatchfilter = null;
        lazyState.current.IsArrivedfilter = null;
        setIsArrivedFilterState(null);
        lazyState.current.IsCheckedInfilter = null;
        setIsCheckedInFilterState(null);
        lazyState.current.HotelFilter = null;
        setHotelFilter(null);

        lazyState.current.CityFilter = null;
        setCityfilter(null);
        lazyState.current.Designationfilter = null;
        setDesignationFilterState(null);

        lazyState.current.ArrivalTimefilter = null;
        setArrivalTimeFilterState(null);
        lazyState.current.DepartureTimefilter = null;
        setDepartureTimeFilterState(null);

        lazyState.current.flightNo = null;
        setFilterFlightNo(null);

        lazyState.current.returnflightno = null;
        setFilterReturnFlightNo(null);

        lazyState.current.Toeventcityfilter = null;
        setToEventCityFilterState(null);
        lazyState.current.Fromeventcityfilter = null;
        setFromEventCityFilterState(null);
        lazyState.current.day1presentfilter = null;
        setDay1PresentFilterState(null);
        lazyState.current.day2presentfilter = null;
        setDay2PresentFilterState(null);
        lazyState.current.TricoConfirmedfilter = null;
        setTricoConfirmedFilterState(null);

        getparticipantlist();
    };

    const isFilterActive = !(
        lazyState.current.CompanyFilter == null &&
        lazyState.current.ParticipantNameFilter == null &&
        lazyState.current.BoardingCityFilter == null &&
        lazyState.current.EmailFilter == null &&
        lazyState.current.MobileNoFilter == null &&
        lazyState.current.serialnumber == null &&
        lazyState.current.inbatchfilter == null &&
        lazyState.current.outbatchfilter == null &&
        lazyState.current.IsArrivedfilter == null &&
        lazyState.current.IsCheckedInfilter == null &&
        lazyState.current.HotelFilter == null &&
        lazyState.current.CityFilter == null &&
        lazyState.current.Designationfilter == null &&
        lazyState.current.ArrivalTimefilter == null &&
        lazyState.current.DepartureTimefilter == null &&
        lazyState.current.flightNo == null &&
        lazyState.current.returnflightno == null &&
        lazyState.current.Toeventcityfilter == null &&
        lazyState.current.Fromeventcityfilter == null &&
        lazyState.current.day1presentfilter == null &&
        lazyState.current.day2presentfilter == null &&
        lazyState.current.TricoConfirmedfilter == null &&
        fullName == null &&
        SerialNumber == null &&
        boardingcityfilter == null &&
        Cityfilter == null &&
        HotelFilter == null &&
        filterFlightNo == null &&
        filterReturnFlightNo == null &&
        filterEmail == null &&
        filterMobileNo == null
    );

    const filterDialogFooter = (
        <div className="filter-modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '0.5rem' }}>
            <Button
                label="Reset"
                icon="pi pi-filter-slash"
                className="p-button-outlined p-button-secondary"
                onClick={() => {
                    removeFilter();
                    setFilterDialog(false);
                }}
                outlined
            />
            <Button
                label="Apply"
                icon="pi pi-check"
                className="p-button-primary"
                onClick={() => SearchFilter()}
            />
        </div>
    );

    // Right Side Toolbar
    const rightToolbarTemplate = () => {
        return (
            <div className="my-2 admin-toolbar-right">
                <Button
                    icon="pi pi-filter"
                    label="Filter"
                    className="p-button-outlined mr-2 mobile-only-btn"
                    onClick={() => setFilterDialog(true)}
                    tooltip="Filter"
                    tooltipOptions={{ position: "bottom", className: "showtooltip" }}
                    outlined
                />
                <Button
                    disabled={!isFilterActive}
                    icon="pi pi-filter-slash"
                    className="p-button-outlined mr-2"
                    onClick={() => removeFilter()}
                    tooltip="Reset Filter"
                    tooltipOptions={{ position: "bottom", className: "showtooltip" }}
                    outlined
                ></Button>
                <AccessControl allowedPermissions={["export:participant"]}>
                    <Button
                        disabled={!(participantlist != null && participantlist.length > 0)}
                        onClick={() => {
                            getparticipantlist(true);
                        }}
                        icon="pi pi-file-excel"
                        className="mr-2"
                        tooltip="Export Excel"
                        tooltipOptions={{ position: "bottom", className: "showtooltip" }}
                        outlined
                    />
                </AccessControl>
            </div>
        );
    };

    return (
        <div className="trico-Grid">
            <Toast ref={toast} />
            {isLoading ? (
                <LoadingSpinner />
            ) : (
                <>
                    <div className="p-col">
                        <div className="card">
                            <h5 className="headerfont">
                                <span>
                                    <i className="fa fa-solid fa-users mr-2"></i>Attendees Status
                                </span>
                            </h5>
                            <Toolbar right={rightToolbarTemplate} className="mb-3"></Toolbar>
                            <Tooltip target="#mailto" content="Mail To" />
                            <Tooltip target="#callto" content="Call To" />

                            {/* Desktop Table View */}
                            <div className="attendee-status-desktop-table">
                                <DataTable size="small" scrollHeight="calc(100vh - 250px)" scrollable className="datatable-responsive admin-datatable" lazy rows={lazyState.current.rows} onSort={onSort} sortField={lazyState.current.sortField} sortOrder={lazyState.current.sortOrder} removableSort stripedRows ref={dt} value={participantlist} responsiveLayout="scroll" filterDisplay={"row"}>
                                    <Column field="serialNumber" header="Id" sortField="SerialNumber" sortable frozen headerStyle={{ width: "3%", minWidth: "5rem" }} filter showFilterMenu={false} filterElement={SerialNumberFilterTemplate} showClearButton></Column>
                                    <Column sortField="FullName" field="fullName" frozen header="Name" sortable headerStyle={{ width: "15%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={UserFilterTemplate} showClearButton></Column>
                                    <Column field="isCheckedInYesNo" sortField="IsCheckedInYesNo" sortable header="Is Checked In" headerStyle={{ width: "10%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={IsCheckedInFilterTemplate}></Column>
                                    <Column field="isArrivedYesNo" sortField="IsArrivedYesNo" sortable header="Is Arrived" headerStyle={{ width: "10%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={IsArrivedFilterTemplate}></Column>
                                    <Column field="presentYesNo" sortField="PresentYesNo" sortable header="Day-1 Present" headerStyle={{ width: "10%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={Day1PresentFilterTemplate}></Column>
                                    <Column field="dayTwoPresentYesNo" sortField="DayTwoPresentYesNo" sortable header="Day-2 Present" headerStyle={{ width: "10%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={Day2PresentFilterTemplate}></Column>
                                    <Column field="hotelName" sortField="HotelName" sortable header="Hotel" headerStyle={{ width: "10%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={HotelFilterTemplate}></Column>
                                    <Column field="flightNo" sortField="FlightNo" header="Flight No" sortable headerStyle={{ width: "15%", minWidth: "15rem" }} filter showFilterMenu={false} filterElement={FlightNoFilterTemplate} style={{ overflowWrap: "anywhere" }}></Column>
                                    <Column field="returnFlightNo" sortField="ReturnFlightNo" header="Return Flight No" sortable headerStyle={{ width: "15%", minWidth: "15rem" }} filter showFilterMenu={false} filterElement={ReturnFlightNoFilterTemplate} style={{ overflowWrap: "anywhere" }}></Column>
                                    <Column
                                        field="arrivalTime"
                                        sortField="ArrivalTime"
                                        sortable
                                        body={(rowData) => <span>{rowData?.arrivalTime ? moment(rowData.arrivalTime).format("DD/MM/YYYY HH:mm") : ""}</span>}
                                        headerStyle={{ width: "10%", minWidth: "15rem" }}
                                        style={{ overflowWrap: "anywhere" }}
                                        header="Arrival"
                                        filter
                                        showFilterMenu={false}
                                        filterElement={ArrivalTimerFilterTemplate}
                                    ></Column>
                                    <Column
                                        field="departureTime"
                                        sortField="DepartureTime"
                                        sortable
                                        body={(rowData) => <span>{rowData?.departureTime ? moment(rowData.departureTime).format("DD/MM/YYYY HH:mm") : ""}</span>}
                                        headerStyle={{ width: "10%", minWidth: "15rem" }}
                                        style={{ overflowWrap: "anywhere" }}
                                        header="Departure"
                                        filter
                                        showFilterMenu={false}
                                        filterElement={DepartureTimerFilterTemplate}
                                    ></Column>
                                    <Column field="tricoConfirmed" sortField="TricoConfirmed" sortable header="Trico Confirmed" headerStyle={{ width: "10%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={TricoConfirmedFilterTemplate} body={TricoConfirmedFilterBodyTemplate} filterField="tricoConfirmed" filterMenuStyle={{ width: '14rem' }} ></Column>
                                    <Column field="inBatchBooking" header="In Batch" sortField="inBatchBooking" sortable filter headerStyle={{ width: "10%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere", minWidth: '14rem' }} showFilterMenu={false} filterElement={InBatchFilterTemplate} body={InBatchFilterBodyTemplate} filterField="InBatchBooking" filterMenuStyle={{ width: '14rem' }}></Column>
                                    <Column field="outBatchBooking" header="Out Batch" sortField="outBatchBooking" sortable filter headerStyle={{ width: "10%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere", minWidth: '14rem' }} showFilterMenu={false} filterElement={OutBatchFilterTemplate} body={OutBatchFilterBodyTemplate} filterField="OutBatchBooking" filterMenuStyle={{ width: '14rem' }}></Column>
                                    <Column body={ButtonPhoneto} sortField="MobileNo" field="mobileNo" header="Mobile No." sortable style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={MobileFilterTemplate}></Column>
                                    <Column body={ButtonMailto} sortField="Email" field="email" header="Email" sortable style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={EmailFilterTemplate}></Column>
                                    <Column field="designation" header="Designation" sortField="Designation" sortable headerStyle={{ width: "10%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={DesignationFilterTemplate}></Column>
                                    <Column field="cityname" header="City" filterField="cityname" sortField="cityname" sortable headerStyle={{ width: "10%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={CityFilterTemplate}></Column>
                                    <Column field="boardingcityname" header="BoardingCity" sortField="boardingcityname" sortable headerStyle={{ width: "10%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={BoardingCityFilterTemplate}></Column>
                                    <Column field="company" header="Company" sortField="company" sortable headerStyle={{ width: "25%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={CompanyFilterTemplate} body={CompanyFilterBodyTemplate} filterField="Company" filterMenuStyle={{ width: '14rem' }} ></Column>
                                    <Column field="travelmode_Inbound" header="Travel In Bound" sortField="Travelmode_Inbound" sortable headerStyle={{ width: "10%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={ToEventCityTemplate}></Column>
                                    <Column
                                        field="travelmode_Outbound"
                                        header="Travel Out Bound"
                                        sortField="Travelmode_Outbound"
                                        sortable
                                        headerStyle={{ width: "10%", minWidth: "15rem" }}
                                        style={{ overflowWrap: "anywhere" }}
                                        filter
                                        showFilterMenu={false}
                                        filterElement={FromEventCityTemplate}
                                    ></Column>
                                </DataTable>
                            </div>

                            {/* Mobile Card View */}
                            <div className="attendee-status-mobile-cards">
                                {participantlist && participantlist.length > 0 ? (
                                    <div className="attendee-card-grid">
                                        {participantlist.map((item, index) => {
                                            const isCheckedIn = item.isCheckedInYesNo === "Yes" || item.isCheckedInYesNo === "YES";
                                            const isArrived = item.isArrivedYesNo === "Yes" || item.isArrivedYesNo === "YES";
                                            const day1Present = item.presentYesNo === "Yes" || item.presentYesNo === "YES";
                                            const day2Present = item.dayTwoPresentYesNo === "Yes" || item.dayTwoPresentYesNo === "YES";

                                            return (
                                                <div className="attendee-mobile-card" key={item.id || item.serialNumber || index}>
                                                    {/* Top header with Sr No, Name, and Trico Confirmed */}
                                                    <div className="attendee-card-top flex justify-content-between align-items-center mb-2">
                                                        <div className="flex align-items-center gap-2">
                                                            <span className="attendee-card-id">#{item.serialNumber || "-"}</span>
                                                            <h6 className="attendee-card-name m-0 font-bold">{item.fullName || "N/A"}</h6>
                                                        </div>
                                                        {item.tricoConfirmed && (
                                                            <span className="attendee-trico-tag">{item.tricoConfirmed}</span>
                                                        )}
                                                    </div>

                                                    {/* Designation & Company */}
                                                    <div className="attendee-card-subinfo text-sm mb-2 text-600">
                                                        {item.designation && <span className="designation-pill">{item.designation}</span>}
                                                        {item.company && (
                                                            <span className="attendee-company-badge">
                                                                <i className="fa fa-building-o mr-1"></i>
                                                                {item.company}
                                                            </span>
                                                        )}
                                                    </div>

                                                    {/* Status Badges Row */}
                                                    <div className="attendee-status-badges flex flex-wrap gap-1 mb-2">
                                                        <span className={`status-pill ${isCheckedIn ? 'status-pill-yes' : 'status-pill-no'}`}>
                                                            <i className={`fa ${isCheckedIn ? 'fa-check-circle' : 'fa-times-circle'} mr-1`}></i>
                                                            Checked In: {item.isCheckedInYesNo || "No"}
                                                        </span>
                                                        <span className={`status-pill ${isArrived ? 'status-pill-yes' : 'status-pill-no'}`}>
                                                            <i className={`fa ${isArrived ? 'fa-check-circle' : 'fa-times-circle'} mr-1`}></i>
                                                            Arrived: {item.isArrivedYesNo || "No"}
                                                        </span>
                                                        <span className={`status-pill ${day1Present ? 'status-pill-yes' : 'status-pill-no'}`}>
                                                            <i className={`fa ${day1Present ? 'fa-check-circle' : 'fa-times-circle'} mr-1`}></i>
                                                            Day 1: {item.presentYesNo || "No"}
                                                        </span>
                                                        <span className={`status-pill ${day2Present ? 'status-pill-yes' : 'status-pill-no'}`}>
                                                            <i className={`fa ${day2Present ? 'fa-check-circle' : 'fa-times-circle'} mr-1`}></i>
                                                            Day 2: {item.dayTwoPresentYesNo || "No"}
                                                        </span>
                                                    </div>

                                                    {/* Details Section */}
                                                    <div className="attendee-card-details">
                                                        {/* Contact Info */}
                                                        <div className="attendee-detail-row">
                                                            {item.mobileNo && (
                                                                <div className="attendee-detail-item">
                                                                    <i className="fa fa-phone text-500 mr-1"></i>
                                                                    <a href={`tel:${item.mobileNo}`} className="linkcolors text-sm">{item.mobileNo}</a>
                                                                </div>
                                                            )}
                                                            {item.email && (
                                                                <div className="attendee-detail-item">
                                                                    <i className="fa fa-envelope-o text-500 mr-1"></i>
                                                                    <a href={`mailto:${item.email}`} className="linkcolors text-sm">{item.email}</a>
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Location & Hotel */}
                                                        <div className="attendee-detail-row">
                                                            {(item.cityname || item.boardingcityname) && (
                                                                <div className="attendee-detail-item">
                                                                    <i className="fa fa-map-marker text-500 mr-1"></i>
                                                                    <span className="text-sm">
                                                                        {item.boardingcityname ? `${item.boardingcityname} (Boarding)` : ''}
                                                                        {item.boardingcityname && item.cityname ? ' • ' : ''}
                                                                        {item.cityname ? item.cityname : ''}
                                                                    </span>
                                                                </div>
                                                            )}
                                                            {item.hotelName && (
                                                                <div className="attendee-detail-item">
                                                                    <i className="fa fa-bed text-500 mr-1"></i>
                                                                    <span className="text-sm">{item.hotelName}</span>
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Inbound Travel */}
                                                        {(item.flightNo || item.arrivalTime || item.travelmode_Inbound || item.inBatchBooking) && (
                                                            <div className="flight-journey-card inbound-journey mt-2">
                                                                <div className="flight-journey-header">
                                                                    <span className="flight-journey-title">
                                                                        <i className="fa fa-plane mr-1 text-blue-600"></i> Inbound Flights
                                                                    </span>
                                                                </div>
                                                                <div className="flight-segments-list">
                                                                    <div className="flight-segment-card">
                                                                        <div className="flight-segment-top">
                                                                            <span className="flight-badge-tag in-tag">INF1</span>
                                                                            {item.flightNo && <span className="flight-no-badge">{item.flightNo}</span>}
                                                                            {item.travelmode_Inbound && <span className="flight-airline-badge">({item.travelmode_Inbound})</span>}
                                                                        </div>
                                                                        {item.arrivalTime && (
                                                                            <div className="flight-route-flow">
                                                                                <div className="route-point arr-point">
                                                                                    <div className="route-label"><i className="fa fa-plane fa-rotate-90 mr-1 text-teal-600"></i>Arr</div>
                                                                                    <div className="route-location">{item.cityname || "Event City"}</div>
                                                                                    <div className="route-time">
                                                                                        <i className="fa fa-clock-o mr-1"></i>
                                                                                        {moment(item.arrivalTime).format("DD/MM/YYYY HH:mm")}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Outbound Travel */}
                                                        {(item.returnFlightNo || item.departureTime || item.travelmode_Outbound || item.outBatchBooking) && (
                                                            <div className="flight-journey-card outbound-journey mt-2">
                                                                <div className="flight-journey-header">
                                                                    <span className="flight-journey-title">
                                                                        <i className="fa fa-plane fa-rotate-180 mr-1 text-orange-600"></i> Outbound Flights
                                                                    </span>
                                                                </div>
                                                                <div className="flight-segments-list">
                                                                    <div className="flight-segment-card">
                                                                        <div className="flight-segment-top">
                                                                            <span className="flight-badge-tag out-tag">OUTF1</span>
                                                                            {item.returnFlightNo && <span className="flight-no-badge">{item.returnFlightNo}</span>}
                                                                            {item.travelmode_Outbound && <span className="flight-airline-badge">({item.travelmode_Outbound})</span>}
                                                                        </div>
                                                                        {item.departureTime && (
                                                                            <div className="flight-route-flow">
                                                                                <div className="route-point dep-point">
                                                                                    <div className="route-label"><i className="fa fa-plane mr-1 text-primary"></i>Dep</div>
                                                                                    <div className="route-location">{item.cityname || "Event City"}</div>
                                                                                    <div className="route-time">
                                                                                        <i className="fa fa-clock-o mr-1"></i>
                                                                                        {moment(item.departureTime).format("DD/MM/YYYY HH:mm")}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="attendee-empty-state text-center p-4 card surface-card">
                                        <i className="fa fa-inbox text-4xl text-400 mb-2"></i>
                                        <p className="text-600 m-0">No records found</p>
                                    </div>
                                )}
                            </div>

                            <Paginator className="justify-content-end admin-paginator" first={lazyState.current.first} rows={lazyState.current.rows} totalRecords={totalRecords} template={template2} rowsPerPageOptions={RowsPerPageDropdown} onPageChange={onBasicPageChange}></Paginator>

                            {/* Mobile Filter Dialog */}
                            <Dialog
                                visible={filterDialog}
                                draggable={false}
                                header={
                                    <div className="dialog-header-content flex align-items-center gap-2">
                                        <i className="fa fa-filter text-primary dialog-header-icon mr-2"></i>
                                        <span className="dialog-header-title">Filter Attendees Status</span>
                                    </div>
                                }
                                modal
                                className="p-fluid admin-dialog attendee-filter-dialog"
                                footer={filterDialogFooter}
                                onHide={() => setFilterDialog(false)}
                            >
                                <div className="filter-dialog-grid">
                                    <div className="filter-field-item">
                                        <label>Sr No.</label>
                                        <InputText id="modal_serialnumber" value={SerialNumber || ""} placeholder="Sr No." onChange={(e) => setSerialNumber(e.target.value)} />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>Name</label>
                                        <InputText id="modal_fullName" value={fullName || ""} placeholder="Enter First Name" onChange={(e) => setfullName(e.target.value)} />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>Company</label>
                                        <MultiSelect
                                            value={lazyState.current.CompanyFilter}
                                            options={companyList}
                                            itemTemplate={CompanyFilterItemTemplate}
                                            optionLabel="name"
                                            onChange={(e) => {
                                                lazyState.current.CompanyFilter = e.target.value ? e.target.value : null;
                                                setcompanyNameFilter(e.value);
                                            }}
                                            placeholder="Select Company"
                                            maxSelectedLabels={1}
                                            filter
                                        />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>Designation</label>
                                        <Dropdown
                                            value={lazyState.current.Designationfilter}
                                            options={Designations.Designation}
                                            optionLabel="name"
                                            showClear
                                            onChange={(e) => {
                                                lazyState.current.Designationfilter = e.target.value ? e.target.value : null;
                                                setDesignationFilterState(e.value);
                                            }}
                                            placeholder="Select Designation"
                                        />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>City</label>
                                        <InputText id="modal_city" value={Cityfilter || ""} placeholder="Enter City" onChange={(e) => setCityfilter(e.target.value)} />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>Boarding City</label>
                                        <InputText id="modal_boardingcityname" value={boardingcityfilter || ""} placeholder="Enter Boarding City" onChange={(e) => setboardingcityfilter(e.target.value)} />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>Email</label>
                                        <InputText id="modal_Email" value={filterEmail || ""} placeholder="Enter Email" onChange={(e) => setFilterEmail(e.target.value)} />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>Mobile No.</label>
                                        <InputText id="modal_Mobile" value={filterMobileNo || ""} placeholder="Enter Mobile No." onChange={(e) => setFilterMobileNo(e.target.value)} />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>Hotel</label>
                                        <InputText id="modal_Hotel" value={HotelFilter || ""} placeholder="Enter Hotel" onChange={(e) => setHotelFilter(e.target.value)} />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>Flight No</label>
                                        <InputText id="modal_flightno" value={filterFlightNo || ""} placeholder="Enter Flight No" onChange={(e) => setFilterFlightNo(e.target.value)} />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>Return Flight No</label>
                                        <InputText id="modal_returnflightno" value={filterReturnFlightNo || ""} placeholder="Enter Return Flight No" onChange={(e) => setFilterReturnFlightNo(e.target.value)} />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>Arrival Time</label>
                                        <Dropdown
                                            value={lazyState.current.ArrivalTimefilter}
                                            options={arrivalDepartureDates}
                                            optionLabel="name"
                                            showClear
                                            onChange={(e) => {
                                                lazyState.current.sortField = "ArrivalTime";
                                                lazyState.current.ArrivalTimefilter = e.target.value ? e.target.value : null;
                                                setArrivalTimeFilterState(e.value);
                                            }}
                                            placeholder="Select Arrival Time"
                                        />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>Departure Time</label>
                                        <Dropdown
                                            value={lazyState.current.DepartureTimefilter}
                                            options={arrivalDepartureDates}
                                            optionLabel="name"
                                            showClear
                                            onChange={(e) => {
                                                lazyState.current.sortField = "DepartureTime";
                                                lazyState.current.DepartureTimefilter = e.target.value ? e.target.value : null;
                                                setDepartureTimeFilterState(e.value);
                                            }}
                                            placeholder="Select Departure Time"
                                        />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>Travel In Bound</label>
                                        <Dropdown
                                            value={lazyState.current.Toeventcityfilter}
                                            options={Travelmodes.Travelmode}
                                            optionLabel="name"
                                            showClear
                                            onChange={(e) => {
                                                lazyState.current.Toeventcityfilter = e.target.value ? e.target.value : null;
                                                setToEventCityFilterState(e.value);
                                            }}
                                            placeholder="Select Travel Mode"
                                        />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>Travel Out Bound</label>
                                        <Dropdown
                                            value={lazyState.current.Fromeventcityfilter}
                                            options={Travelmodes.Travelmode}
                                            optionLabel="name"
                                            showClear
                                            onChange={(e) => {
                                                lazyState.current.Fromeventcityfilter = e.target.value ? e.target.value : null;
                                                setFromEventCityFilterState(e.value);
                                            }}
                                            placeholder="Select Travel Mode"
                                        />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>In Batch</label>
                                        <MultiSelect
                                            value={lazyState.current.inbatchfilter}
                                            options={inBatchList}
                                            itemTemplate={InBatchFilterItemTemplate}
                                            optionLabel="name"
                                            onChange={(e) => {
                                                lazyState.current.inbatchfilter = e.target.value ? e.target.value : null;
                                                setInBatchfilter(e.value);
                                            }}
                                            placeholder="Select In Batch"
                                            maxSelectedLabels={1}
                                            filter
                                        />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>Out Batch</label>
                                        <MultiSelect
                                            value={lazyState.current.outbatchfilter}
                                            options={outBatchList}
                                            itemTemplate={OutBatchFilterItemTemplate}
                                            optionLabel="name"
                                            onChange={(e) => {
                                                lazyState.current.outbatchfilter = e.target.value ? e.target.value : null;
                                                setOutBatchfilter(e.value);
                                            }}
                                            placeholder="Select Out Batch"
                                            maxSelectedLabels={1}
                                            filter
                                        />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>Trico Confirmed</label>
                                        <MultiSelect
                                            value={lazyState.current.TricoConfirmedfilter}
                                            options={tricoConfirmedList}
                                            itemTemplate={TricoConfirmedFilterItemTemplate}
                                            optionLabel="name"
                                            onChange={(e) => {
                                                lazyState.current.TricoConfirmedfilter = e.target.value ? e.target.value : null;
                                                setTricoConfirmedFilterState(e.value);
                                            }}
                                            placeholder="Select Trico Confirmed"
                                            maxSelectedLabels={1}
                                            filter
                                        />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>Is Checked In</label>
                                        <Dropdown
                                            value={lazyState.current.IsCheckedInfilter}
                                            options={GlobalEnum.GlobalEnum}
                                            optionLabel="name"
                                            showClear
                                            onChange={(e) => {
                                                lazyState.current.IsCheckedInfilter = e.target.value ? e.target.value : null;
                                                setIsCheckedInFilterState(e.value);
                                            }}
                                            placeholder="Select Checked In"
                                        />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>Is Arrived</label>
                                        <Dropdown
                                            value={lazyState.current.IsArrivedfilter}
                                            options={GlobalEnum.GlobalEnum}
                                            optionLabel="name"
                                            showClear
                                            onChange={(e) => {
                                                lazyState.current.IsArrivedfilter = e.target.value ? e.target.value : null;
                                                setIsArrivedFilterState(e.value);
                                            }}
                                            placeholder="Select Arrived"
                                        />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>Day-1 Present</label>
                                        <Dropdown
                                            value={lazyState.current.day1presentfilter}
                                            options={GlobalEnum.GlobalEnum}
                                            optionLabel="name"
                                            showClear
                                            onChange={(e) => {
                                                lazyState.current.day1presentfilter = e.target.value ? e.target.value : null;
                                                setDay1PresentFilterState(e.value);
                                            }}
                                            placeholder="Select Day-1 Present"
                                        />
                                    </div>
                                    <div className="filter-field-item">
                                        <label>Day-2 Present</label>
                                        <Dropdown
                                            value={lazyState.current.day2presentfilter}
                                            options={GlobalEnum.GlobalEnum}
                                            optionLabel="name"
                                            showClear
                                            onChange={(e) => {
                                                lazyState.current.day2presentfilter = e.target.value ? e.target.value : null;
                                                setDay2PresentFilterState(e.value);
                                            }}
                                            placeholder="Select Day-2 Present"
                                        />
                                    </div>
                                </div>
                            </Dialog>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default ViewAttendeeStatus;
